<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
<div>
  {{ platformMediaCustomableName }}
  <input type="file" aria-label="file input" (change)="onFileSelected($event)" />
  <button (click)="onUpload()">Upload</button>
  <button (click)="onClear()">Discard</button>
  @if (uploadProgress$ | async; as progress) {
  <div>Progress: {{ progress }}%</div>
  }
</div>

@if (docData$ | async; as doc) {
<div>
  @if (fetchFile$ | async; as options) {
  <div>
    @if (doc.mediaKind.includes('json')) {
    <ng-lottie [options]="lottieOptions" width="100px" height="100px"> </ng-lottie>
    }
  </div>
  } @if (doc.mediaKind.includes('video')) {
  <video controls width="414" height="896">
    <source [src]="doc.url" [type]="doc.mediaKind" />
  </video>
  } @if (doc.mediaKind.includes('image')) {
  <img [src]="doc.url" width="100" height="100" [alt]="doc.url" />
  } @if ( !doc.mediaKind.includes('json') && !doc.mediaKind.includes('video') &&
  !doc.mediaKind.includes('image') ) {
  <a [href]="doc.url" target="_blank">{{ doc.mediaKind }}: {{ doc.url }}</a>
  }
</div>
}
